/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ifAuthenticated } from '../routeValidation';
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

// Documents
const Accounts = () =>
  import(
    /* webpackChunkName: "Accounts" */ '@/views/Accounts/account.vue'
  );

const permissionsPages = {
  path: '/',
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  name: 'accountList',
  children: [
    {
      path: '/accounts-list',
      component: Accounts,
      meta: {
        navbarType: 'light',
      },
    }
  ],
};

export default permissionsPages;
